module.exports = __webpack_public_path__ + "img/icon-submit-feedback.3e6a7549.svg";